import { getCancellationPolicyInfo } from "halifax";
import { PriceQuote, RoomProduct, Cfar } from "redmond";

export const getCancellationPolicyInfoFromQuote = ({
  quote,
  product,
  getCfarSecondaryText,
}: {
  quote: PriceQuote | undefined | null;
  // cancellationPolicy will be sourced from the room product as a fallback when the quote isn’t available yet in the flow.
  product?: RoomProduct | undefined | null;
  getCfarSecondaryText: (cfarCancellation: Cfar) => string;
}) => {
  const cancellationPolicy =
    quote?.cancellationPolicy ?? product?.cancellationPolicy;
  if (cancellationPolicy != null) {
    return getCancellationPolicyInfo(cancellationPolicy, getCfarSecondaryText);
  }
  return null;
};
